import React, {Component} from 'react';
import Modal from '../../components/UI/Modal/Modal';
import Aux from '../Aux/Aux';
import {baseURL} from '../../axios-cmk'

const withErrorHandler = (WrappedComponent, axios) => {
    return class extends Component {
        state = {
            error: null,
            should_logout: false
        };

        componentWillMount() {
            this.setState({should_logout: false});
            this.reqInterceptor = axios.interceptors.request.use(req => {
                this.setState({error: null});
                return req;
            });
            this.resInterceptor = axios.interceptors.response.use(
                res => {
                    if (res['data']['redirect']) {
                        document.location=baseURL + res['data']['redirect']
                    }
                    return res
                },
                error => {
                    if (error && error.response.status === 403) {
                        this.setState({should_logout: true});
                    } else {
                        this.setState({error: error});
                    }
                }
            );
}

componentWillUnmount()
{
    axios.interceptors.request.eject(this.reqInterceptor);
    axios.interceptors.response.eject(this.resInterceptor);
}

errorConfirmedHandler = () => {
    this.setState({error: null});
}


render()
{

    const new_props = {
        ...this.props,
        should_logout: this.state.should_logout
    }

    return (
        <Aux>
            <Modal
                show={this.state.error}
                modalClosed={this.errorConfirmedHandler}>
                {this.state.error ? this.state.error.message : null}
                {this.state.error ? this.state.error.response.status : null}
            </Modal>
            <WrappedComponent {...new_props} />
        </Aux>
    )
}
}
}

export default withErrorHandler;


// WEBPACK FOOTER //
// ./src/hoc/withErrorHandler/withErrorHandler.js